import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton,
} from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { ButtonElement, TypographyElement } from '@plugins/next-cms-core';
import { FiX } from 'react-icons/fi';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'next-i18next';

export default function GlobalNotice(props) {
  const {
    data,
    isGlobalNoticeHidden,
  } = props;
  const { t } = useTranslation();
  const [isDismissed, setDismissed] = useState(getState());

  const {
    isGlobalNoticeVisible,
    globalNoticeTitle,
    globalNoticeText,
    globalNoticeButtons,
  } = data ?? {};

  if (!isGlobalNoticeVisible || isGlobalNoticeHidden) {
    return null;
  }

  const handleToggleState = () => {
    if (getState()) {
      resetState();
    } else {
      setState();
    }

    setDismissed(getState());
  };

  return (
    <Dialog
      aria-describedby="global-notice-description"
      aria-labelledby="global-notice-title"
      fullWidth
      hideBackdrop
      onClose={handleToggleState}
      open={!isDismissed}
      PaperProps={{
        style: {
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle id="global-notice-title">
        {globalNoticeTitle}
      </DialogTitle>
      <IconButton
        aria-label="Schließen"
        onClick={handleToggleState}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <FiX />
      </IconButton>
      <DialogContent>
        <DialogContentText id="global-notice-description">
          {globalNoticeText && (
            <TypographyElement data={globalNoticeText} />
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-start', px: 3, pb: 3 }}>
        <Grid2 container justifyContent="left" spacing={3}>
          {(globalNoticeButtons ?? []).map((button) => (
            <Grid2
              key={button.id}
              size={{
                md: 'auto',
                xs: 12,
              }}
            >
              <ButtonElement
                aria-label="Termin-Vereinbaren"
                color="primary"
                data={button}
                fullWidth
                onClick={handleToggleState}
                variant="contained"
              />
            </Grid2>
          ))}
        </Grid2>
      </DialogActions>
    </Dialog>
  );
}

GlobalNotice.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.shape({
    is_global_notice_visible: PropTypes.bool,
    global_notice_title: PropTypes.string,
    global_notice_text: PropTypes.string,
    global_notice_buttons: PropTypes.arrayOf(
      PropTypes.shape(ButtonElement.propTypes.data),
    ),
  }),
};

const STORAGE_KEY = 'global-notice-dismissed';

function getState() {
  const itemStr = localStorage.getItem(STORAGE_KEY);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }

  return item.value;
}

function setState() {
  const now = new Date();
  const item = {
    value: true,
    expiry: now.getTime() + 1000 * 60 * 60 * 24,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(item));
}

function resetState() {
  localStorage.removeItem(STORAGE_KEY);
}
